import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";

const WorkspaceGateShellComponent = () => {
    const shellStyle = { height: "calc(100vh - 64px)" };

    return (
        <Box style={{ ...shellStyle, overflow: "hidden" }}>
            <Outlet />
        </Box>
    );
};

export default WorkspaceGateShellComponent;
